import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIsChangeSubscriptionDialogOpen, setIsChangeSubscriptionDialogOpen } from "../reducers/subscription/subscriptionReducer";
import { SubscriptionProviderInstance } from "../@shared/services/SubscriptionProvider";
import { NotificationModel, NotificationModelType } from "../reducers/main/mainModel";
import { onThrowAlert } from "../sagas/dataSaga/dataSagaActions";
import { getIsAuthorized, setIsAuthorized } from "../reducers/main/mainReducer";
import { UserProviderInstance } from "../@shared/services/UserProvider";


export type useManageSubscriptionProps = {

}

export type useManageSubscriptionResult = {
    onChange: () => Promise<void>,
    isDialogOpen: boolean,
    isLoading: boolean,
    licenseIdValue: string,
    onSetLicenseIdValue: (value: string) => void,
    setIsDialogOpen: (value: boolean) => void
}

export const useChangeSubscription = (): useManageSubscriptionResult => {
    const dispatch = useDispatch();
    const isDialogOpen = useSelector(getIsChangeSubscriptionDialogOpen);
    const [isLoading, setIsLoading] = useState(false);
    const [licenseIdValue, setLicenseIdValue] = useState<string>("");

    const user = useSelector(getIsAuthorized);
    const userLicense = useMemo(() => user?.license, [user?.license]);

    const setIsDialogOpen = useCallback((value: boolean) => {
        dispatch(setIsChangeSubscriptionDialogOpen(value));
    }, [dispatch]);

    const subscriptionProviderInstance = useMemo(() => SubscriptionProviderInstance.getInstance(), [])
    const userProviderInstance = useMemo(() => UserProviderInstance, [])

    const onSetLicenseIdValue = (value: string) => {
        setLicenseIdValue(value);
    }

    const onChange = useCallback(async () => {
        if (userLicense?.id === licenseIdValue) {
            dispatch(onThrowAlert({
                message: "A license cannot be modified to the same license.",
                lifeTime: 3000,
                type: NotificationModelType.Error
            } as NotificationModel));
        }
        setIsLoading(true);
        var res = await subscriptionProviderInstance.applyId(licenseIdValue);
        if (res.status !== 200) {
            dispatch(onThrowAlert({
                message: res.data,
                lifeTime: 3000,
                type: NotificationModelType.Error
            } as NotificationModel));
        }
        else {
            dispatch(onThrowAlert({
                message: "License was successfully changed",
                lifeTime: 3000,
                type: NotificationModelType.Success
            } as NotificationModel));
        }
        setIsLoading(false);
        setIsDialogOpen(false);
        const currentUser = await userProviderInstance.current()
        dispatch(setIsAuthorized(currentUser.data));
        onSetLicenseIdValue("");
    }, [userLicense?.id, licenseIdValue, subscriptionProviderInstance, setIsDialogOpen, userProviderInstance, dispatch]);

    return {
        onSetLicenseIdValue,
        licenseIdValue,
        isLoading,
        onChange,
        setIsDialogOpen,
        isDialogOpen
    }
}